import { Text, Badge, Box } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import { useBinderCardColors } from '../hooks/useBinderCardColors';
import { formatSimpleValue } from '../utils/fieldFormatting';
import ValidationBadge from './ValidationBadge';

interface PleasureUseCardProps {
  data?: any;
}

const PleasureUseCard = ({ data }: PleasureUseCardProps) => {
  const colors = useBinderCardColors();

  // Get processed vehicles data
  const vehicles = data?.vehicles || [];

  const formatPleasureStatus = (isPleasure: any) => {
    return (
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {isPleasure ? 'Yes' : 'No'}
      </Badge>
    );
  };

  const formatCommuteDistance = (distance: any) => {
    return (
      <Text color={colors.valueColor} fontSize="sm" fontWeight="medium">
        {distance} km
      </Text>
    );
  };

  // Create table rows from processed vehicle data
  const vehicleRows = vehicles.map((vehicle: any) => {
    return [
      vehicle.name,
      formatPleasureStatus(vehicle.isPleasure),
      formatCommuteDistance(vehicle.commuteKm),
      vehicle.remarks ? (
        <Text fontSize="sm">{formatSimpleValue(vehicle.remarks)}</Text>
      ) : (
        <Text fontSize="xs" color="gray.500" fontStyle="italic">
          No remarks
        </Text>
      ),
      <ValidationBadge status={vehicle.isValid ? 'pass' : 'caution'} />,
    ];
  });

  const headers = ['Vehicle', 'Pleasure', 'Commute (km)', 'Remarks', 'Outcome'];

  // Handle empty state
  if (vehicleRows.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No vehicle data available
        </Text>
      </Box>
    );
  }

  return (
    <DataTableCard
      description="Check vehicle usage classification for each vehicle."
      headers={headers}
      rows={vehicleRows}
    />
  );
};

export default PleasureUseCard;
